var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"cell-container"},_vm.$listeners),[_c('div',{staticClass:"body-2 text--secondary"},[_vm._v(_vm._s(_vm.item.ddd))]),_c('div',{staticClass:"time-day",class:{ selected: _vm.selected, today: _vm.item.today, disabled: _vm.item.disabled }},[_vm._v(_vm._s(_vm.item.dayofmonth))])])
}
var staticRenderFns = []

export { render, staticRenderFns }